import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Navimumbaitokolhapurcab() {



const cardData = {
  keyword: " Navi Mumbai to Kolhapur Cab",

headingDescription:
  "Omshree Cab offers reliable and comfortable Navi Mumbai to Kolhapur cab services for travelers planning a convenient and safe journey to one of Maharashtra’s culturally rich cities. Kolhapur is famous for its historic temples, traditional cuisine, Kolhapuri chappals, and vibrant cultural heritage. Whether you are planning a family trip, pilgrimage, weekend getaway, or corporate visit, our cab service ensures a smooth and enjoyable ride with experienced drivers and well-maintained vehicles. The distance from Navi Mumbai to Kolhapur is approximately 375–400 km and the journey typically takes 7 to 8 hours via the NH48 highway, depending on traffic. We provide flexible booking options including one-way trips, round trips, and multi-day travel plans with transparent per-kilometer pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With punctual pickups from any location in Navi Mumbai, professional chauffeurs experienced in long-distance driving, and 24/7 customer support, Omshree Cab is your trusted partner for Navi Mumbai to Kolhapur cab services.",

topPlaces: [
  {
    title: "Mahalakshmi Temple",
    description:
      "Mahalakshmi Temple is one of the most prominent landmarks of Kolhapur and an important religious site for devotees. The temple is dedicated to Goddess Mahalakshmi and features intricate architecture, historic carvings, and a peaceful spiritual environment. Pilgrims visit throughout the year to offer prayers and attend religious ceremonies. Travelers using a cab from Navi Mumbai can comfortably plan their visit and spend ample time exploring the temple complex and nearby markets."
  },
  {
    title: "Rankala Lake",
    description:
      "Rankala Lake is a scenic freshwater lake located in the heart of Kolhapur, surrounded by gardens, walking paths, and historic monuments. Visitors can enjoy boat rides, leisurely walks along the promenade, and evening relaxation while soaking in the serene surroundings. The lake area is also popular for photography and local street food. Traveling by cab from Navi Mumbai allows tourists to visit the lake conveniently and spend sufficient time exploring this tranquil spot."
  },
  {
    title: "New Palace",
    description:
      "New Palace, also known as Shree Chhatrapati Shahu Museum, is a grand architectural marvel in Kolhapur. It showcases the royal heritage of the Maratha dynasty and houses artifacts, weaponry, paintings, and historical exhibits. Visitors can explore the museum to learn about the city’s history, culture, and regal past. A cab service from Navi Mumbai provides hassle-free transportation, ensuring travelers can comfortably enjoy the palace visit along with other Kolhapur attractions."
  },
  {
    title: "Panhala Fort",
    description:
      "Panhala Fort, located near Kolhapur, is a historic hill fort offering panoramic views of the surrounding landscape. The fort holds significant historical importance, being a strategic site during Maratha reign. Visitors can explore the fort’s ramparts, watchtowers, temples, and enjoy trekking around the scenic hills. A cab from Navi Mumbai ensures easy access to the fort and a convenient, stress-free journey to this historic location."
  },
  {
    title: "Bhuikot Fort",
    description:
      "Bhuikot Fort is an ancient fort in Kolhapur featuring impressive stone structures, gates, and scenic views. Travelers interested in history and architecture can explore the fort, learn about its significance, and enjoy the panoramic vistas of the surrounding countryside. A taxi from Navi Mumbai makes it easier to reach the fort comfortably and allows visitors to integrate it into a full day of sightseeing in Kolhapur."
  },
  {
    title: "Jagadguru Shree Muktanand Math",
    description:
      "Jagadguru Shree Muktanand Math is a spiritual and cultural center in Kolhapur where devotees participate in meditation, prayers, and religious programs. The serene atmosphere and religious significance attract pilgrims and tourists alike. Visitors traveling from Navi Mumbai can use a cab service to reach the math conveniently and explore its spiritual and cultural offerings."
  },
  {
    title: "Kopeshwar Temple",
    description:
      "Kopeshwar Temple is a historic temple dedicated to Lord Shiva, known for its remarkable architecture and intricate carvings. The temple attracts devotees and architecture enthusiasts from across the country. Travelers visiting Kolhapur by cab from Navi Mumbai can plan a relaxed visit to the temple and appreciate its historic and religious importance."
  },
  {
    title: "Rankala Garden",
    description:
      "Rankala Garden is a well-maintained park located near Rankala Lake, featuring walking paths, fountains, and open green spaces. Visitors can enjoy leisurely walks, family outings, and photography in a peaceful environment. A taxi from Navi Mumbai ensures convenient access to the garden, making it easy for travelers to combine the visit with other nearby attractions in Kolhapur."
  },
  {
    title: "Gokulwadi",
    description:
      "Gokulwadi is a popular area in Kolhapur known for local markets, street food, and vibrant cultural atmosphere. Visitors can explore traditional Kolhapuri cuisine, shop for handicrafts, and experience local life. Using a cab from Navi Mumbai provides comfortable travel to this bustling part of the city and allows tourists to enjoy the authentic flavor of Kolhapur."
  },
  {
    title: "Bhavani Mandap",
    description:
      "Bhavani Mandap is a historic landmark in Kolhapur, formerly used for royal gatherings and public ceremonies. The site features classic Maratha architecture and attracts visitors interested in history and culture. Traveling by cab from Navi Mumbai allows tourists to conveniently visit Bhavani Mandap along with other major attractions in Kolhapur for a full cultural experience."
  }
],



services: [
{
name: "Navi Mumbai to Kolhapur Cab",
description: "Navi Mumbai to Kolhapur cab service provides comfortable long-distance transportation for travelers visiting the historic city of Kolhapur. This route is popular among devotees visiting Mahalaxmi Temple and tourists exploring Kolhapur’s cultural heritage. Our fleet includes AC sedans, SUVs, and spacious MPV vehicles suitable for highway journeys. Professional drivers ensure safe driving and punctual pickup services across Navi Mumbai. Pickup is available from homes, offices, hotels, railway stations, and airport locations. Comfortable seating and luggage space ensure relaxed travel for families and groups. Ideal for pilgrimage travel, tourism trips, and business journeys."
},
{
name: "Navi Mumbai to Kolhapur Taxi",
description: "Navi Mumbai to Kolhapur taxi service offers dependable transportation between Navi Mumbai and Kolhapur city. Vehicles provide comfortable seating and smooth highway performance suitable for long-distance travel. Professional drivers ensure punctual pickup services and safe driving throughout the journey. Air-conditioned vehicles provide comfortable travel for passengers during the trip. Ideal for families, pilgrims, and tourists visiting Kolhapur."
},
{
name: "Cab from Navi Mumbai to Kolhapur",
description: "Cab from Navi Mumbai to Kolhapur provides reliable intercity transportation for passengers traveling from Navi Mumbai to Kolhapur. Vehicles are well maintained and suitable for highway travel with comfortable seating and luggage capacity. Professional drivers ensure safe driving and punctual pickup services across Navi Mumbai."
},
{
name: "Taxi from Navi Mumbai to Kolhapur",
description: "Taxi from Navi Mumbai to Kolhapur provides comfortable long-distance transportation for passengers visiting Kolhapur city. Vehicles provide air-conditioned interiors and smooth ride quality suitable for highway travel. Professional drivers ensure punctual pickup services and safe driving throughout the route."
},
{
name: "Navi Mumbai Kolhapur Cab Service",
description: "Navi Mumbai Kolhapur cab service provides convenient transportation for travelers planning visits to Kolhapur. Vehicles provide comfortable seating and reliable highway performance suitable for extended journeys. Professional drivers ensure safe driving and punctual pickup services across Navi Mumbai."
},
{
name: "Navi Mumbai Kolhapur Taxi Service",
description: "Navi Mumbai Kolhapur taxi service offers dependable road transportation for passengers traveling between Navi Mumbai and Kolhapur. Vehicles provide comfortable seating and smooth ride quality suitable for long journeys. Professional drivers ensure punctual pickup and safe travel throughout the route."
},
{
name: "Navi Mumbai to Kolhapur Cab Booking",
description: "Navi Mumbai to Kolhapur cab booking allows passengers to reserve vehicles easily for long-distance travel. Online and phone booking options provide quick confirmation and flexible travel scheduling. Vehicles provide comfortable seating and reliable performance suitable for highway journeys."
},
{
name: "Navi Mumbai to Kolhapur Taxi Booking Online",
description: "Navi Mumbai to Kolhapur taxi booking online provides convenient digital reservations for travelers planning Kolhapur trips. Passengers can easily schedule rides online and receive instant booking confirmation. Vehicles provide comfortable seating and smooth ride quality."
},
{
name: "Navi Mumbai to Kolhapur Cab Price",
description: "Navi Mumbai to Kolhapur cab price options provide transparent fare estimates depending on vehicle category and travel distance. Travelers can choose sedans, SUVs, or MPV vehicles depending on comfort needs and group size."
},
{
name: "Navi Mumbai to Kolhapur Taxi Fare",
description: "Navi Mumbai to Kolhapur taxi fare services offer flexible pricing depending on vehicle type and travel duration. Passengers can choose economical sedans or spacious SUVs depending on their travel preferences."
},
{
name: "Navi Mumbai to Kolhapur One Way Cab",
description: "Navi Mumbai to Kolhapur one way cab service provides economical intercity transportation without return charges. Vehicles provide comfortable seating and smooth highway performance suitable for long-distance travel."
},
{
name: "Navi Mumbai to Kolhapur Round Trip Taxi",
description: "Navi Mumbai to Kolhapur round trip taxi service provides convenient travel for passengers planning return journeys after visiting Kolhapur. Vehicles remain available according to the travel plan ensuring comfortable transportation in both directions."
},
{
name: "Mahalaxmi Temple Cab Kolhapur",
description: "Mahalaxmi Temple cab Kolhapur service provides dedicated transportation for devotees visiting the famous Mahalaxmi Temple in Kolhapur. Vehicles provide comfortable seating and reliable highway performance suitable for pilgrimage travel."
},
{
name: "Innova Cab Navi Mumbai Kolhapur",
description: "Innova cab Navi Mumbai Kolhapur service provides spacious MPV transportation ideal for families and small groups traveling together. Toyota Innova vehicles offer comfortable seating and smooth highway performance suitable for long-distance journeys."
}
],

tableData: [
["Navi Mumbai to Kolhapur Cab","Navi Mumbai to Kolhapur Taxi"],
["Cab from Navi Mumbai to Kolhapur","Taxi from Navi Mumbai to Kolhapur"],
["Navi Mumbai Kolhapur Cab Service","Navi Mumbai Kolhapur Taxi Service"],
["Navi Mumbai to Kolhapur Cab Booking","Navi Mumbai to Kolhapur Taxi Booking Online"],
["Navi Mumbai to Kolhapur Cab Price","Navi Mumbai to Kolhapur Taxi Fare"],
["Navi Mumbai to Kolhapur One Way Cab","Navi Mumbai to Kolhapur Round Trip Taxi"],
["Mahalaxmi Temple Cab Kolhapur","Innova Cab Navi Mumbai Kolhapur"]
],


whychoose: [
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in long-distance travel from Navi Mumbai to Kolhapur. They are familiar with major highways including the Mumbai–Pune Expressway and NH48 ensuring a safe and smooth journey."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for Navi Mumbai to Kolhapur cab bookings. Customers receive clear details about per-kilometer fares, toll charges, and driver allowance before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Navi Mumbai to Kolhapur cab service operates 24 hours a day. Whether you want to start early morning or travel overnight, we provide reliable cab booking anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are well maintained, fully air-conditioned, and regularly cleaned to ensure passengers enjoy a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Options",
    WhyChoosedescription: "We offer flexible travel options including one-way cab bookings, round trips, and multi-day travel packages from Navi Mumbai to Kolhapur."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs provides a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for families and group travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Navi Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, railway stations, and business locations anywhere in Navi Mumbai for a smooth start to your Kolhapur journey."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Navi Mumbai to Kolhapur trips thanks to our punctual drivers, comfortable vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide cab service from Navi Mumbai to Kolhapur?", answer: "Yes, Omshree Cabs provides reliable cab services from Navi Mumbai to Kolhapur for both one-way and round-trip travel." },
  { question: "What is the distance from Navi Mumbai to Kolhapur?", answer: "The distance from Navi Mumbai to Kolhapur is approximately 380 km and the journey usually takes around 7 to 8 hours depending on traffic and road conditions." },
  { question: "Can I book a one-way cab from Navi Mumbai to Kolhapur?", answer: "Yes, we offer both one-way and round-trip cab services between Navi Mumbai and Kolhapur." },
  { question: "Which vehicles are available for this route?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers depending on passenger requirements." },
  { question: "Is the cab service available 24 hours?", answer: "Yes, our Navi Mumbai to Kolhapur cab service operates 24/7 for passenger convenience." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Can we stop during the journey?", answer: "Yes, passengers can request stops during the journey for meals, refreshments, or rest breaks." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and holiday travel." },
  { question: "Can we visit Mahalaxmi Temple in Kolhapur?", answer: "Yes, many travelers book Navi Mumbai to Kolhapur cabs for visiting the famous Mahalaxmi Temple and local sightseeing." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Deshmukh",
    feedback:
      "We booked Omshree Cabs for our Navi Mumbai to Kolhapur trip. The driver was professional and the long journey was very comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Patil",
    feedback:
      "Excellent cab service. Clean car, polite driver, and smooth travel from Navi Mumbai to Kolhapur.",
    rating: 5
  }
];








































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Omshree Cab",
  "description": "Omshree Cab offers reliable cab services from Navi Mumbai to Kolhapur. Book one-way or round-trip taxis, including Innova cabs, for Mahalaxmi Temple visits and other travel needs.",
  "telephone": "+91 9892544084",
  "url": "https://www.omshreecab.com",
  "areaServed": {
    "@type": "City",
    "name": "Navi Mumbai, Maharashtra, India"
  },
  "serviceType": [
    "Navi Mumbai to Kolhapur Cab",
    "Outstation Taxi",
    "One Way Cab Service",
    "Round Trip Cab",
    "Innova Cab Rental"
  ]
};








  return (
    <div>
      
<Helmet>
  <title>Navi Mumbai to Kolhapur Cab | Omshree Cab</title>
  <meta
    name="description"
    content="Book a cab from Navi Mumbai to Kolhapur with Omshree Cab. One-way and round-trip taxi services available including Innova cabs. Perfect for Mahalaxmi Temple visits and outstation travel."
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/93.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaitokolhapurcab;